module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"actions":{"logout":"Log out"},"headings":{"application":"Application","social":"Social media"}},"fi":{"actions":{"logout":"Kirjaudu ulos"},"headings":{"application":"Sovellus","social":"Some"}},"sv":{"actions":{"logout":"Logga ut"},"headings":{"application":"Applikation","social":"Sociala medier"}}}')
  delete Component.options._Ctor
}
